import { Directive, ElementRef, Input, Renderer2, OnInit, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[spFallbackImg]'
})
export class SppFallbackImgDirective implements AfterViewInit {
    @Input('spFallbackImg') public fallbackUrl!: string;

    private imgElement!: HTMLImageElement;
    private sourceElement!: NodeListOf<HTMLSourceElement>;

    private alreadyTriedFallback = false;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    public ngAfterViewInit(): void {
        this.imgElement = this.el.nativeElement.querySelector('img');
        this.sourceElement = this.el.nativeElement.querySelectorAll('source');

        if (this.imgElement && this.sourceElement) {
            this.renderer.listen(this.imgElement, 'error', (e) => {
                if (!this.alreadyTriedFallback) {
                    this.alreadyTriedFallback = true;
                    this.sourceElement.forEach((node) => {
                        node.remove();
                    });
                    this.renderer.setAttribute(this.imgElement, 'src', this.fallbackUrl);
                }
            });
        }
    }
}
